import { createElement, type ComponentType } from 'react';
import Experiences from 'components/Experiences';
import Home from 'components/Home/Home';
import { getHomeComponent } from 'utils/getHomeComponent';

// The experiences results view (includes the cart) that old-landing (v1) brands render on
// the /search route — the same render the /e route uses. `asHomePage` leaves `showTitle`
// unset (false), which is the Experiences branch that shows the cart icon. Experiences is a
// JS component whose props TS infers as all-required, so cast to render it with just
// `asHomePage` (its other props have runtime defaults).
const ExperiencesSearchResults = () =>
  createElement(
    Experiences as unknown as ComponentType<{ asHomePage?: boolean }>,
    { asHomePage: true },
  );

// /search mirrors getHomeComponent (calendar → schedule, new landing → MainLandingPage,
// loading → null), except old-landing brands render the experiences results view so the
// cart is reachable there instead of the cart-less Home landing.
export const getSearchComponent = (
  args: Parameters<typeof getHomeComponent>[0],
) => {
  const component = getHomeComponent(args);
  return component === Home ? ExperiencesSearchResults : component;
};
